import React from "react";
import { lessBelowHundredReport } from "../../../locales/en";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import ReportPageAction from "../page-action/ReportPageAction";
import LoansLessHundredTable from "../../../components/table/all-tables/reportable/loanslesshundred/LoansLessHundredTable";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";

export default function LoansLessHundred() {
  return (
    <>
      <TablePagesTitle mainTitle={lessBelowHundredReport?.mainTitle} />

      <ReportPageAction subheading={lessBelowHundredReport?.subH2} />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-4 mb-2 mx-0 ">
          <div className="col-md-12">
            <LoansLessHundredTable />
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
